import { useState, useEffect } from "react";

import Board from "./components/Board";

const TableLayoutSettingsDnD = (props) => {
    const { layout, onChangeLayout } = props;

    /** States */
    const [COLS, setCOLS] = useState(layout?.cols || []);
    const [LIST, setLIST] = useState(layout?.list || []);
    const [ROWS, setROWS] = useState(layout?.rows || []);
    /** /end States */

    /** Effects */
    useEffect(() => {
        setCOLS(layout.cols);
        setLIST(layout.list);
        setROWS(layout.rows);
    }, [layout]);

    /** - watch current layout */
    useEffect(() => {
        onChangeLayout({ cols: COLS, list: LIST, rows: ROWS });
    }, [COLS, LIST, ROWS]);
    /** /end Effects */

    return <Board layout={layout} onChangeLayout={onChangeLayout} />;
};

export default TableLayoutSettingsDnD;
